module.exports = __webpack_public_path__ + "img/Niehaus@1x.995ba2b0.webp";